export default __webpack_public_path__ + "static/Office_image_3-0cd8db7656769d8ef9dfc9f27f78dc73.png";